import React from "react";
import { Tooltip } from "antd";
import tick_blue from "../Image/tick_blue.png";

const NCDLT_DOC_URL =
  "https://www.kayantoken.io/uploads/2026/10/KYNCO2-Token-DACS-Classification.pdf";

// Blue = Verified Compliance, green (same badge, hue-shifted) = Environmental Stewardship.
// Each tick has its own hover label; clicking either opens the doc.
function DoubleTick({ className = "" }) {
  const open = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(NCDLT_DOC_URL, "_blank", "noopener,noreferrer");
  };
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
      }}
    >
      <Tooltip title="Verified">
        <button className="b-c-t b-n c-p" onClick={open}>
          <img src={tick_blue} className="w-1_5" alt="Verified Compliance" />
        </button>
      </Tooltip>
      <Tooltip title="Environmental Stewardship">
        <button className="b-c-t b-n c-p" onClick={open}>
          <img
            src={tick_blue}
            className="w-1_5"
            alt="Environmental Stewardship"
            style={{
              filter: "hue-rotate(-90deg) saturate(0.9) brightness(0.85)",
            }}
          />
        </button>
      </Tooltip>
    </span>
  );
}

export default DoubleTick;
